import MainStyle from "components/UI/main.module.scss";
import { useState, useEffect } from 'react';

// This will manage the modal state globally
let showToastMessageCallback = null;
let hideToastMessageCallback = null;

export const useToastMessage = () => {
  return { showToastMessage: showToastMessageCallback, hideToastMessage: hideToastMessageCallback };
};

export const InfoToast = () => {
  const [displayToast,    setDisplayToast   ] = useState(false);
  const [messageBody,     setMessageBody    ] = useState({ header: '', message: '' });
  const [animationPhase,  setAnimationPhase ] = useState(''); // in | out

  // Show with animation
  showToastMessageCallback = ({ header, message }) => {
    setMessageBody({ header, message });
    setAnimationPhase('in');
    setDisplayToast(true);

    // Auto-hide
    setTimeout(() => {
      setAnimationPhase('out');
    }, 2500);
  };

  // Manual hide
  hideToastMessageCallback = () => setAnimationPhase('out');

  // Handle animation end
  const handleAnimationEnd = () => {
    if (animationPhase === 'out') {
      setDisplayToast(false);
    }
  };

  return (
    <>
      {displayToast && (
        <div
            className={[
              MainStyle.toast_dialog,
              animationPhase === 'in'
                ? MainStyle.toast_dialog_in
                : animationPhase === 'out'
                ? MainStyle.toast_dialog_out
                : ''
            ].join(" ")}
            onAnimationEnd={handleAnimationEnd}
            onClick={() => {setAnimationPhase('out');}}
        >
          <div className={[MainStyle.toast_content, MainStyle.rounded_3, MainStyle.shadow, MainStyle.border, MainStyle.bg_card].join(" ")}>
            <div className={[MainStyle.m_3, MainStyle.px_3].join(" ")}>
              <div className={MainStyle.toast_header}>
                <span className={[MainStyle.my_2, MainStyle.text_body, MainStyle.fs_4, MainStyle.fw_semibold].join(" ")}>
                  {messageBody.header}
                </span>
              </div>
              <div className={[MainStyle.toast_body, MainStyle.mb_3].join(" ")}>
                <span className={[MainStyle.text_body, MainStyle.fs_6].join(" ")}>
                  {messageBody.message}
                </span>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

